import React from 'react';
import { FormattedMessage } from 'react-intl';
import featureImg1 from '../Images/land-finding-img1.png';
import featureImg2 from '../Images/land-finding-img2.png';
import { PrimaryButton } from '../../../components';
import css from './Sections.module.css';

function FeatureSection() {
  return (
    <div className={css.featureSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featureInfo}>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg1} alt="" />
            </div>
            <div className={css.featureDetails}>
              <h3>
                <FormattedMessage id="StructuralAndCivilEngineersPage.FeatureSection.structuralTitle" />
              </h3>
              <p>
                <FormattedMessage id="StructuralAndCivilEngineersPage.FeatureSection.structuralDescription" />
              </p>
            </div>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg2} alt="" />
            </div>
            <div className={css.featureDetails}>
              <h3>
                <FormattedMessage id="StructuralAndCivilEngineersPage.FeatureSection.civilTitle" />
              </h3>
              <p>
                <FormattedMessage id="StructuralAndCivilEngineersPage.FeatureSection.civilDescription" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeatureSection;
